import { createActions } from 'redux-actions';

export default createActions(
  {
    // Gripper
    APPEND_GRIPPER: () => ({}),
    // Set Relay
    APPEND_SET_RELAY: () => ({}),
    // Cycle Relay
    APPEND_CYCLE_RELAY: () => ({}),
    // Set Servo
    APPEND_SET_SERVO: () => ({}),
    // Cycle Servo
    APPEND_CYCLE_SERVO: () => ({}),
    // Delay Until
    APPEND_DELAY_UNTIL: () => ({}),
    // Jump To Item
    APPEND_JUMP_TO_ITEM: () => ({}),
    // Change Altitude
    APPEND_CHANGE_ALTITUDE: (altitude) => ({ altitude }),
    // Change Speed
    APPEND_CHANGE_SPEED: (speed) => ({ speed }),
    // VTOL Transition
    APPEND_VTOL_TRANSITION: () => ({}),
    // Wait For Distance
    APPEND_WAIT_FOR_DISTANCE: () => ({}),
    // Wait For Yaw
    APPEND_WAIT_FOR_YAW: () => ({}),
    // Trigger Parachute
    APPEND_TRIGGER_PARACHUTE: () => ({}),
    // Guided Enable
    APPEND_GUIDED_ENABLE: () => ({}),
    // Guided Limits
    APPEND_GUIDED_LIMITS: () => ({}),
    // Autotune Enable
    APPEND_AUTOTUNE_ENABLE: () => ({}),
    // Set Region Of Interest None
    APPEND_SET_ROI_NONE: () => ({}),
    // Command
    CHANGE_COMMAND_TYPE: (index, type) => ({ index, type }),
    // Fence
    ADD_FENCE: (type, data) => ({ type, data }),
    EDIT_FENCE: (index, values) => ({ index, values }),
    REMOVE_FENCE: (index) => ({ index }),
  },
  { prefix: 'MISSION/MAVLINK' },
);
